<template>
	<aside class="bb-nested-view">
		<h1>Partners Sub Route</h1>
		<h2>CONTENT HERE</h2>
		<h3>CONTENT HERE</h3>
		<h4>CONTENT HERE</h4>
		<h5>CONTENT HERE</h5>
	</aside>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';

export default {
	name: 'BbPartners',
	components: {
		/*
  HelloWorld,
*/
	},
};
</script>
